var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreensGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5828 16.6585C8.37446 16.6002 6.17436 17.0375 4.16146 17.9455C3.9517 18.0401 3.85835 18.2868 3.95297 18.4966C4.04759 18.7064 4.29434 18.7997 4.50411 18.7051C6.40445 17.8479 8.48361 17.4351 10.5715 17.4918C10.579 17.492 10.5866 17.492 10.5941 17.4918C12.682 17.4351 14.7611 17.8479 16.6615 18.7051C16.8712 18.7997 17.118 18.7064 17.2126 18.4966C17.3072 18.2868 17.2139 18.0401 17.0041 17.9455C14.9912 17.0375 12.7911 16.6002 10.5828 16.6585Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83301 2.91683C1.60479 2.91683 1.41634 3.10528 1.41634 3.3335V14.1668C1.41634 14.395 1.60479 14.5835 1.83301 14.5835H19.333C19.5612 14.5835 19.7497 14.395 19.7497 14.1668V3.3335C19.7497 3.10528 19.5612 2.91683 19.333 2.91683H1.83301ZM0.583008 3.3335C0.583008 2.64504 1.14456 2.0835 1.83301 2.0835H19.333C20.0215 2.0835 20.583 2.64504 20.583 3.3335V14.1668C20.583 14.8553 20.0215 15.4168 19.333 15.4168H1.83301C1.14456 15.4168 0.583008 14.8553 0.583008 14.1668V3.3335Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33268 14.5835C9.5628 14.5835 9.74935 14.77 9.74935 15.0002V17.1252C9.74935 17.3553 9.5628 17.5419 9.33268 17.5419C9.10256 17.5419 8.91602 17.3553 8.91602 17.1252V15.0002C8.91602 14.77 9.10256 14.5835 9.33268 14.5835Z",
    fill: "#A6A6A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8327 14.5835C12.0628 14.5835 12.2493 14.77 12.2493 15.0002V17.1252C12.2493 17.3553 12.0628 17.5419 11.8327 17.5419C11.6026 17.5419 11.416 17.3553 11.416 17.1252V15.0002C11.416 14.77 11.6026 14.5835 11.8327 14.5835Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreensGray);
export default __webpack_public_path__ + "static/media/screens_gray.ef4d89a47b1a311e749b6fc15c385adf.svg";
export { ForwardRef as ReactComponent };